export default __webpack_public_path__ + "static/media/cfile.c5106097.svg";